app.ApplicantView = (
    function () {
        var view = {

            //Index Page
            Initialize: function () {

                //Functionality that does not need to be reset every duplicate
                $('#update-evaluate-and-hire-candidate').dirty({
                    preventLeaving: true,
                    leavingMessage: 'There are unsaved changes on this page which will be discarded if you do not save.'
                });

                //when clicking a checkbox
                $("[name='HideCandidateDistrict']").on("change",
                    function () {
                        app.ApplicantSearch.ChangeHideText($(this).is(":checked"));

                        $("#OriginalStateDistrict").val(!$(this).is(":checked"));

                        $("#confirmDistrict").modal({ show: true, backdrop: 'static', keyboard: false });
                    });

                //when clicking a checkbox
                $("[name='HideCandidate']").on("change",
                    function () {
                        app.ApplicantSearch.ChangeHideText($(this).is(":checked"));

                        $("#OriginalStateVacancy").val(!$(this).is(":checked"));

                        $("#confirmVacancy").modal({ show: true, backdrop: 'static', keyboard: false });
                    });
            },
            CancelDistrictHide: function () {
                $("[name='HideCandidateDistrict']").prop("checked", $("#OriginalStateDistrict").val() == "true");

            },
            CancelVacancyHide: function () {
                $("[name='HideCandidate']").prop("checked", $("#OriginalStateVacancy").val() == "true");
            },
            ChangeHideText: function(isChecked) {
                if (isChecked) {
                    $(".hideText").text("hide");
                } else {
                    $(".hideText").text("unhide");
                }
            },
        };

        return view;

    }()
);